<!--suppress HtmlFormInputWithoutLabel -->
<template>
  <div v-if="emitOnEnter">
    <input :type="type" :id="id" :value="value" ref="text" :name="name"
           :style="getWidth"
           :disabled="disabled"
           :readonly="readonly"
           :placeholder="placeholder"
           @keydown.enter.prevent="emitValue"
           :class="isValidClass">
    <div v-if="(isPosted && warningField) || customWarning" :class="validFeedbackClass">
      <fa-icon icon="angle-up"/>
      {{ warningText }}
    </div>
  </div>
  <div v-else>
    <input :type="type" :id="id" :value="value" ref="text" :name="name"
           :style="getWidth"
           :disabled="disabled"
           :readonly="readonly"
           :placeholder="placeholder"
           @input="$emit('input', $event.target.value)"
           :class="isValidClass">
    <div v-if="(isPosted && warningField) || customWarning" :class="validFeedbackClass">
      <fa-icon icon="angle-up"/>
      {{ warningText }}
    </div>
  </div>
</template>

<script>
import { API_WARN_FIELDS, API_POSTED } from '@/store/api/postStatus.types'

export default {
  props: {
    id: { type: String, default: null },
    name: {type: String, required: false, default: null},
    value: {type: [String, Number], required: false},
    customClass: {type: String, required: false, default: 'form-control'},
    placeholder: {type: String, required: false, default: null},
    field: {type: String, required: false, default: ''},
    focused: {type: Boolean, required: false, default: false},
    lightMode: {type: Boolean, required: false, default: false},
    disabled: {type: Boolean, required: false, default: false},
    readonly: {type: Boolean, required: false, default: false},
    type: {type: String, required: false, default: 'text'},
    width: { type: String, required: false, default: '100%' },
    emitOnEnter: {type: Boolean, required: false, default: false}
  },

  directives: {
    focus: {
      inserted: (el) => {
        el.focus()
      }
    }
  },

  data () {
    return {
      customWarning: null
    }
  },

  mounted () {
    if (this.focused) {
      this.$refs.text.focus()
    }
  },

  methods: {
    emitValue () {
      this.$parent.$emit('inputData', { value: this.getValue(), name: this.name })
      this.$refs.text.value = null
    },

    getWarningField () {
      return this.$store.getters[API_WARN_FIELDS].find(field => {
        return (Object.keys(field)[0] === this.field)
      })
    },

    getValue () {
      return this.$refs.text.value
    },

    setCustomWarning (warning) {
      this.customWarning = warning
    },

    clearCustomWarning () {
      this.customWarning = null
    },

    focus () {
      this.$refs.text.focus()
    }
  },

  computed: {
    getWidth () {
      if (this.width) {
        return 'width: ' + this.width
      } else {
        return ''
      }
    },

    warningField () {
      return this.getWarningField()
    },

    warningText () {
      let warning = this.getWarningField()
      if (warning) {
        return warning[Object.keys(warning)[0]]
      } else {
        return this.customWarning
      }
    },

    validFeedbackClass () {
      if (this.lightMode) {
        if (this.getWarningField() || this.customWarning) {
          return 'invalid-feedback invalid-feedback-light'
        } else {
          return 'valid-feedback valid-feedback-light'
        }
      } else {
        if (this.getWarningField() || this.customWarning) {
          return 'invalid-feedback'
        } else {
          return 'valid-feedback'
        }
      }
    },

    isValidClass () {
      if (this.lightMode) {
        if (this.getWarningField() || this.customWarning) {
          return this.customClass + ' is-invalid is-invalid-light'
        } else {
          // return 'is-valid is-valid-light'
          return this.customClass
        }
      } else {
        if (this.getWarningField() || this.customWarning) {
          return this.customClass + ' is-invalid'
        } else {
          // return 'is-valid'
          return this.customClass
        }
      }
    },

    isPosted () {
      return this.$store.getters[API_POSTED]
    }
  },

  components: {
  }
}
</script>

<style lang="scss">
  @import "~sass-material-colors/sass/sass-material-colors";

  .is-invalid-light {
    background-color: white !important;
    border: 1px solid material-color('red', '50') !important;
  }

  .is-invalid-light:active {
    background-color: white !important;
    border: 1px solid material-color('red', '50') !important;
  }

  .is-valid-light {
    background-color: white !important;
    border: 1px solid #ced4da !important;
  }

  .is-valid-light:active {
    background-color: white !important;
    border: 1px solid material-color('green', '50') !important;
  }

  .valid-feedback-light {
    color: material-color('green', '400') !important;
  }

  .invalid-feedback-light {
    color: material-color('red', '400') !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/inputs/TextInput.vue